import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicFooter from "@/components/PublicFooter";

const LOGO = "/brand/mtg_logo.svg";

function TenantSite({ slug, name, tagline, primary, accent, badge, ctaLabel, testid, isReal }) {
  return (
    <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-[0_30px_80px_-40px_rgba(16,50,79,0.35)] bg-white">
      <div className="flex items-center gap-2 px-4 py-2.5 bg-slate-50 border-b border-slate-200">
        <span className="w-2.5 h-2.5 rounded-full bg-red-400"></span>
        <span className="w-2.5 h-2.5 rounded-full bg-yellow-400"></span>
        <span className="w-2.5 h-2.5 rounded-full bg-green-400"></span>
        <span className="ml-3 text-xs text-slate-500 truncate">{isReal ? "claveo.fr" : `${slug}.fr`}</span>
      </div>
      <div style={{ background: primary, color: "white" }} className="px-8 py-14 relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-30" style={{ background: accent, filter: "blur(50px)" }}></div>
        <div className="relative text-xs font-bold uppercase tracking-widest" style={{color: accent}}>{badge}</div>
        <h3 className="relative mt-2 font-display text-3xl font-extrabold leading-tight">{name}</h3>
        <p className="relative mt-3 opacity-80 max-w-md">{tagline}</p>
        <Link
          to={`/quote/${slug}`}
          className="relative mt-6 inline-flex items-center gap-2 rounded-full font-semibold px-6 py-3 text-sm transition-base hover:brightness-110"
          style={{ background: accent, color: primary }}
          data-testid={testid}
        >
          {ctaLabel} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="px-8 py-6 grid grid-cols-3 gap-4 text-xs text-slate-500 bg-slate-50">
        <div><div className="font-semibold text-slate-700">Interventions</div>7j/7</div>
        <div><div className="font-semibold text-slate-700">Devis</div>en ligne</div>
        <div><div className="font-semibold text-slate-700">Zone</div>locale</div>
      </div>
    </div>
  );
}

export default function DemoPage() {
  return (
    <div className="min-h-screen kf-mesh">
      <div className="px-6 md:px-12 py-6 md:py-10 max-w-6xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2">
          <img src={LOGO} alt="MonTempsGagné" className="h-9" />
        </Link>
      </div>
      <div className="px-6 md:px-12 pb-16 max-w-6xl mx-auto">
        <Link to="/" className="text-sm text-slate-500 hover:text-[#16324F]">← Retour</Link>
        <div className="mt-6 max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-widest text-[#19C3B3]">Démonstration multi-entreprises</div>
          <h1 className="mt-2 font-display text-4xl md:text-6xl font-extrabold text-[#16324F] tracking-tight">Un moteur, plusieurs entreprises.</h1>
          <p className="mt-4 text-slate-600 text-lg">
            MonTempsGagné est un moteur de devis multi-entreprises. Voici une <b className="text-[#16324F]">entreprise pilote réelle</b> et un second <b className="text-[#16324F]">environnement de démonstration</b> pour montrer comment le produit s'adapte à plusieurs entreprises.
          </p>
        </div>
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <TenantSite
            slug="claveo"
            name="Claveo"
            tagline="Serrurerie automobile réelle utilisée pour tester MonTempsGagné sur des demandes de devis métier."
            primary="#16324F"
            accent="#19C3B3"
            badge="Entreprise pilote"
            ctaLabel="Tester MonTempsGagné avec Claveo"
            testid="demo-cta-claveo"
            isReal
          />
          <TenantSite
            slug="cle-express"
            name="Clé Express"
            tagline="Un second environnement configuré avec une identité, des tarifs et des disponibilités différents."
            primary="#0E3A2E"
            accent="#FF7A59"
            badge="Démonstration"
            ctaLabel="Voir une autre configuration"
            testid="demo-cta-cle-express"
          />
        </div>
        <div className="mt-14 rounded-3xl montempsgagne-bg-navy p-8 md:p-10">
          <div className="text-xs font-bold uppercase tracking-widest text-[#19C3B3]">Un moteur, plusieurs entreprises</div>
          <h2 className="mt-2 font-display text-2xl md:text-3xl font-extrabold text-white">Chaque serrurier conserve son univers.</h2>
          <p className="mt-3 text-white/80 max-w-3xl">
            Tarifs, disponibilités, règles métier et identité restent propres à chaque entreprise. Aucune donnée n&apos;est partagée.
          </p>
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
